import './eventHandlers';
import './languageHelper';
import './search';
import './xor';
import './nav';